export function SettingsVerticalIcon({
  color = 'currentColor',
  size = 24,
  ...otherProps
}: {
  size?: number | string
} & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={otherProps['aria-label'] ? undefined : 'true'}
      {...otherProps}
    >
      <path d="M19 3L19 7M19 21L19 11M12 3L12 15M12 21L12 19M5 3L5 5M5 21L5 9" />
      <circle cx="19" cy="9" r="2" transform="rotate(90 19 9)" />
      <circle cx="12" cy="17" r="2" transform="rotate(90 12 17)" />
      <circle cx="5" cy="7" r="2" transform="rotate(90 5 7)" />
    </svg>
  )
}
